module.exports = __webpack_public_path__ + "static/media/icon5.bdfd53ff.png";